// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetRealEstateListModel, IMappers, TGetRealEstateListResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRealEstateListV2ResponseSchema } from '../../entities/property/GetRealEstateListV2ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetRealEstateListModel(): TGetRealEstateListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cian-dobro',
    pathApi: '/v2/get-real-estate-list/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetRealEstateListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetRealEstateList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetRealEstateListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetRealEstateListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetRealEstateListModel(),
    config,
  )) as FetchResponse<TGetRealEstateListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRealEstateListV2ResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetRealEstateListResponse>;
}
